"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upperAlpha = exports.lowerAlpha = exports.orderedAlpha = void 0;
exports.orderedAlpha = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'n',
    'm',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
];
exports.lowerAlpha = ['lower-alpha', 'lower-latin'];
exports.upperAlpha = ['upper-alpha', 'upper-latin'];
//# sourceMappingURL=ordered.type.js.map